import SkillFlipCard from "./SkillFlipCard";

export const technicalArsenal = [
    {
        id: 1,
        category: "Development",
        description:
            "Core technologies I use to build scalable, high-performance web applications from idea to production.",
        tools: ["React.js", "Next.js", "Tailwind CSS", "Firebase", "Node.js", "MongoDB"],
        nestedSkills: [
            { id: 1, name: "HTML", level: 95, insight: "Strong foundation in semantic markup and accessible web structure." },
            { id: 2, name: "CSS", level: 90, insight: "Crafting responsive, visually clean, and scalable UI layouts." },
            { id: 3, name: "JavaScript", level: 85, insight: "Building interactive, dynamic user experiences with clean logic." },
            { id: 4, name: "React.js", level: 80, insight: "Component-driven architecture for scalable frontend applications." },
            { id: 5, name: "Next.js", level: 75, insight: "SEO-friendly, performance-optimized React applications." },
            { id: 6, name: "Sass", level: 90, insight: "Writing maintainable and modular styles with ease." },
            { id: 7, name: "Bootstrap", level: 80, insight: "Rapid UI development with consistent design systems." },
            { id: 8, name: "Material UI", level: 70, insight: "Building elegant interfaces using ready-made components." },
            { id: 9, name: "React Native", level: 60, insight: "Cross-platform mobile app development with React principles." },
            { id: 10, name: "Node.js", level: 55, insight: "Server-side logic and API handling using JavaScript." },
            { id: 11, name: "Express.js", level: 55, insight: "Building REST APIs, middleware handling, and backend routing." },
            { id: 12, name: "MongoDB", level: 60, insight: "NoSQL database handling for flexible data models." },
            { id: 13, name: "Firebase", level: 65, insight: "Authentication, realtime data, and backend-as-a-service workflows." },
            { id: 14, name: "Laravel", level: 50, insight: "MVC-based backend development with clean architecture." },
            { id: 15, name: "Php", level: 50, insight: "Server-side scripting for dynamic web applications and legacy system support." },
            { id: 16, name: "Python", level: 50, insight: "Scripting, automation, and problem-solving with a clean and readable syntax." },
        ]
    },
    {
        id: 2,
        category: "AI & Automation",
        description:
            "Using AI tools and automation to boost creativity, productivity, development speed, and problem-solving in real-world projects.",
        tools: [
            "AI Prompting",
            "Workflow Automation",
            "AI-assisted Development",
            "Content & Design AI",
            "Productivity Optimization"
        ],
        nestedSkills: [
            { id: 17, name: "ChatGPT", level: 85, insight: "Coding help, ideation, debugging, content writing, UI/UX thinking, and problem-solving." },
            { id: 18, name: "Gemini AI", level: 75, insight: "Research, creative thinking, documentation, and alternative AI perspectives." },
            { id: 19, name: "Grok AI", level: 65, insight: "Real-time reasoning, trend analysis, and conversational insights." },
            { id: 20, name: "DeepSeek", level: 60, insight: "Technical explanations, code understanding, and learning support." },
            { id: 21, name: "Copilot", level: 70, insight: "AI-powered coding assistance for faster development and reduced boilerplate." },
            { id: 22, name: "Tabnine", level: 65, insight: "Improving coding speed with AI-based code completions and suggestions." },
            { id: 23, name: "Stitch AI", level: 60, insight: "Experimenting with AI-generated UI layouts and creative workflows." },
            { id: 24, name: "Suno AI", level: 70, insight: "Generating music, sound experiments, and audio-assisted workflows to enhance creative projects." }
        ]
    },
    {
        id: 3,
        category: "Platforms",
        description: "Platforms and services I regularly use for version control, deployment, hosting, collaboration, and day-to-day development workflows.",
        tools: [
            "GitHub",
            "GitLab",
            "Bitbucket",
            "Vercel",
            "Netlify",
            "Hostinger",
            "GoDaddy",
            "Firebase",
            "EmailJS",
            "YouTube Studio",
            "Postman"
        ],
        nestedSkills: [
            { id: 24, name: "GitHub", level: 85, insight: "Primary platform for version control, project management, collaboration, and open-source learning." },
            { id: 25, name: "GitLab", level: 70, insight: "Used for repository management and understanding CI/CD workflows in team-based projects." },
            { id: 26, name: "Bitbucket", level: 65, insight: "Experience with private repositories and structured team collaboration." },
            { id: 27, name: "Vercel", level: 80, insight: "Deploying Next.js and React projects with optimized performance and seamless CI integration." },
            { id: 28, name: "Netlify", level: 75, insight: "Hosting frontend projects with quick builds, previews, and form handling." },
            { id: 29, name: "Hostinger", level: 70, insight: "Managing shared hosting, domains, and production websites using cPanel." },
            { id: 30, name: "GoDaddy", level: 65, insight: "Domain management, DNS configuration, and basic hosting services." },
            { id: 31, name: "Firebase Console", level: 75, insight: "Managing authentication, hosting, Firestore, and backend services from a single dashboard." },
            { id: 32, name: "EmailJS", level: 70, insight: "Client-side email handling for contact forms without custom backend setup." },
            { id: 33, name: "Postman", level: 85, insight: "Testing APIs, debugging requests, and validating backend workflows." },
            { id: 34, name: "YouTube Studio", level: 65, insight: "Managing and publishing creative content, music, and project showcases." }
        ]
    },
    {
        id: 4,
        category: "Creative Tools",
        description: "Creative tools I use to design interfaces, craft visuals, produce music, and experiment with AI-assisted creativity.",
        tools: [
            "Figma",
            "Canva",
            "FL Studio",
            "BandLab",
            "Google Colab",
            "NotebookLM",
            "VS Code",
            "VN Studio"
        ],
        nestedSkills: [
            {
                id: 35,
                name: "Figma",
                level: 70,
                insight: "Designing user-centric interfaces, creating prototypes, and collaborating visually with teams."
            },
            {
                id: 37,
                name: "Canva",
                level: 70,
                insight: "Quick visual design, social media graphics, banners, and presentation layouts."
            },
            {
                id: 38,
                name: "FL Studio",
                level: 60,
                insight: "Composing music and beats as a creative outlet beyond code and design."
            },
            {
                id: 39,
                name: "BandLab",
                level: 60,
                insight: "Collaborative music creation and experimental sound design."
            },
            {
                id: 45,
                name: "Google Colab",
                level: 65,
                insight: "Running creative AI experiments, prototyping models, and generating interactive content with Python notebooks."
            },
            {
                id: 46,
                name: "NotebookLM",
                level: 60,
                insight: "Leveraging AI-assisted note-taking, knowledge exploration, and creative documentation for projects."
            },
            {
                id: 47,
                name: "VS Code",
                level: 80,
                insight: "Writing scripts, experimenting with code-based creative projects, and integrating tools seamlessly."
            },
            {
                id: 48,
                name: "VN Studio",
                level: 60,
                insight: "Editing videos, creating cinematic content, and producing storytelling visuals efficiently."
            }
        ]
    }
];


const SkillsSection = () => {


    return (
        <div className="w-full">

            {/* Header */}
            <div className="flex flex-col items-center text-center mb-16">
                <h2 className="reveal reveal-delay-1 text-4xl md:text-5xl font-bold text-[#0d121b] dark:text-white font-display tracking-tight">
                    Tech Stack & <span className="text-primary italic">Toolbox</span>
                </h2>
                <p className="text-sm text-gray-500 dark:text-gray-400 mt-3">
                    The core technologies and professional tools I use to bring ideas to life-from architecture to deployment.
                </p>
            </div>

            {/* Integrated Flip Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                {technicalArsenal.map((item, index) => (
                    <SkillFlipCard
                        key={item.id}
                        item={item}
                        index={index}
                        // Passing the already-nested skills directly
                        relatedSkills={item.nestedSkills}
                    />
                ))}
            </div>
        </div>
    );
};

export default SkillsSection;